package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class PostDto(
    val id: Int,
    val title: String,
    val contentMarkdown: String? = null,
    val contentHtml: String? = null,
    val content: String? = null, // Deprecated: for backwards compatibility
    val imageUrl: String? = null, // Deprecated: use images instead
    val imageIds: List<Int> = emptyList(),
    val images: List<PostImageDto>? = null, // Only in detail response
    val tags: List<TagDto>? = null, // Only in detail response
    val status: String? = null,
    val createdAt: String,
    val updatedAt: String,
    // Default to 0 to handle legacy data without authorId
    // When 0, ownership checks should treat this as "unknown author"
    val authorId: Int = 0,
    val author: AuthorDto? = null,
)

@Serializable
data class AuthorDto(
    val id: Int,
    val username: String? = null,
)

@Serializable
data class CreatePostRequestDto(
    val title: String,
    val contentMarkdown: String,
    val content: String? = null, // Deprecated: for backwards compatibility
    val imageUrl: String? = null, // Deprecated: use imageIds instead
    val imageIds: List<Int>? = null,
)

@Serializable
data class UpdatePostRequestDto(
    val title: String? = null,
    val contentMarkdown: String? = null,
    val content: String? = null, // Deprecated: for backwards compatibility
    val imageUrl: String? = null, // Deprecated: use imageIds instead
    val imageIds: List<Int>? = null,
    val status: String? = null,
)

@Serializable
data class UpdatePostStatusRequestDto(
    val status: String,
)

@Serializable
data class DeleteResponseDto(
    val ok: Boolean,
)

@Serializable
data class BulkDeleteRequestDto(
    val ids: List<Int>,
)

@Serializable
data class BulkDeleteResponseDto(
    val ok: Boolean,
    val deletedCount: Int,
)

@Serializable
data class SearchResponseDto(
    val results: List<PostDto>,
    val pagination: SearchPaginationDto,
    val query: String,
)

@Serializable
data class SearchPaginationDto(
    val page: Int,
    val pageSize: Int,
    val total: Int,
    val totalPages: Int,
)
